<div class="details-panel">
  <pa-submit-proposal-left class="details-left" [step]="step" />
  <pa-submit-proposal-right class="details-right" [step]="step" />
</div>
